import {
  JobCatalogTreePageDocument,
  MoveJobCatalogTreeNodeDocument,
  MoveJobCatalogTreeNodeMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useMoveJobCatalogTreeNode = () => {
  const [mutate, { loading }] = useMutation(MoveJobCatalogTreeNodeDocument, {
    extractorFn: (data: MoveJobCatalogTreeNodeMutation) =>
      data.jobCatalogMutations.moveJobcatalogTreeNode,
    refetchQueries: [JobCatalogTreePageDocument],
    awaitRefetchQueries: true,
  })

  const moveNode = (companyId: number, nodeUuid: string, newParentUuid: string) => {
    return mutate({
      variables: {
        companyId,
        nodeUuid,
        newParentUuid,
      },
    })
  }

  return { moveNode, loading }
}
